<template>
    <div class="cf-c-data-card-section">
        <h5 class="cf-c-data-card-section__title">
            {{ title }}
        </h5>
        <p class="cf-c-data-card-section__ctn">
            <span
                v-if="content === null || content === undefined"
                class="cf-c-data-card-section__ctn-item"
                :class="textColorStyles"
            >
                <!-- Render nothing if content is null/undefined -->
            </span>
            <span
                v-else-if="!multipleContentLines"
                class="cf-c-data-card-section__ctn-item"
                :class="textColorStyles"
            >
                {{ content }}
            </span>
            <span
                v-else
                v-for="(item, index) in content"
                :key="index"
                class="cf-c-data-card-section__ctn-item"
            >
                {{ item }}
            </span>
        </p>
    </div>
</template>

<script>
import { isArray } from 'lodash-es'

export default {
    props: {
        title: {
            type: String,
            required: true
        },

        content: {
            type: [String, Array, Number, null],
            required: false,
            default: null
        },

        textColor: {
            type: String,
            required: false,
            default: ''
        }
    },

    computed: {
        textColorStyles () {
            if (this.textColor.length) {
                return 'cf-u-color-' + this.textColor
            }

            return ''
        },

        multipleContentLines () {
            return Array.isArray(this.content) && this.content.length > 0
        }
    }
}
</script>
